// @ts-nocheck



import React, { useCallback } from 'react';
import {
  Filter,
  FilterContainer,
  FilterButtonsContainer } from
'../../../../components';

import { SectionContent } from '../components/elements';








export const CommonFilter = (props) => {
  const resolvedChildren = useCallback((child) => {
    try {
      return React.Children.only(child).type === React.Fragment ?
      child.props.children :
      child;
    } catch {
      return child;
    }
  }, []);

  return (
    <SectionContent>
      <FilterContainer>
        <Filter
          cleanFilter={props.cleanFilter}
          applyFilter={props.applyFilter}
          initialValues={props.filter}
          additionalFilter={props.additionalFilter}>

          {({
            values,
            changeValue,
            applyFilter,
            cleanFilter,
            showAdditional,
            handleAdditional
          }) =>
          <>
              {resolvedChildren(props.children?.(values, changeValue))}
              <FilterButtonsContainer
              applyFilter={applyFilter}
              cleanFilter={cleanFilter}
              showAdditional={showAdditional}
              handleAdditional={props.additionalFilter && handleAdditional} />

            </>
          }
        </Filter>
      </FilterContainer>
    </SectionContent>);

};

export default CommonFilter;